import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { combineLatest, map, of, switchMap } from 'rxjs';
import { defaultLanguage } from '../../consts';
import { getFullPathFromUrlSegments } from '../../lib/get-full-path';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';
import { GrowthBookService } from '../../services/growth-book.service';
import { LanguageService } from '../../services/language.service';

export const isRedirectGuard: CanMatchFn = (a, state) => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  const growthBookService = inject(GrowthBookService);
  const languageService = inject(LanguageService);

  return growthBookService.load().pipe(
    switchMap(() => {
      const lang = languageService.currentLanguage();
      const value = getFullPathFromUrlSegments(state, true, languageService.currentLanguage()).join('/') || 'home';

      const searches = [
        lang === defaultLanguage
          ? of(null)
          : storyblokService.getStories({ filter_query: [{ key: `alias.alias__i18n__${lang}`, value }] }),
        storyblokService.getStories({ filter_query: [{ key: 'alias.alias', value }] }),
      ];

      return combineLatest(searches).pipe(
        map(resps => {
          const resp = resps.find(r => r?.stories.length);
          if (!resp) return false;
          return true;
        })
      );
    })
  );
};
